import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_CUSTOMER_OPINION_STATS_REQUEST]: isLoading,
  [types.FETCH_CUSTOMER_OPINION_STATS_FAILURE]: isEnding,
  [types.FETCH_CUSTOMER_OPINION_STATS_SUCCESS]: isEnding,
});
